import { useState, useRef } from 'react';

export type SlideDirection = 'left' | 'right' | '';


export function useCalendarSlideTransition(enableAnimation: boolean = true) {
  const [slideDirection, setSlideDirection] = useState<SlideDirection>('');
  const [isAnimating, setIsAnimating] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  // Call this before updating months
  const triggerSlide = (direction: SlideDirection, duration = 400) => {
    if (!enableAnimation) {
      setSlideDirection('');
      setIsAnimating(false);
      return;
    }
    setSlideDirection(direction);
    setIsAnimating(true);
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setSlideDirection('');
      setIsAnimating(false);
    }, duration);
  };

  return {
    slideDirection: enableAnimation ? slideDirection : '',
    triggerSlide,
    isAnimating: enableAnimation ? isAnimating : false,
  };
}
